const getUserAvatarUrl = (user) => {
  if (!user.id && !user.pictureUrlCdn && !user.picture) return void 0;
  const url = user.pictureUrlCdn || user.picture || `${process.env.NEXT_PUBLIC_FABRIC_CDN_URL}/users/avatars/${user.id}.jpeg`;
  if (!user.modifiedAt) return url;
  return `${url}?${new Date(user.modifiedAt).getTime()}`;
};

export { getUserAvatarUrl };
//# sourceMappingURL=getUserAvatarUrl.js.map
